module.exports = {"[placeholder] Owner":"ProgramOwner","Meeting Requestor":"MeetingRequestor","Collaborator – Any Settings":"AnySettings","Collaborator – Can Approve Invoices":"CanApproveInvoices","Collaborator – Can Invite to [placeholder]":"CanInviteToProgram","Collaborator – Display on POs":"DisplayOnPOs","Collaborator – Receives PO Notifications":"ReceivesPONotifications","Collaborator – Receives RFP Notifications":"ReceivesRFPNotifications","Collaborator – Receives Status Notifications":"ReceivesStatusNotifications","Custom Title":"CustomTitle"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/team-tab-type.json
// module id = /C9s
// module chunks = 12